/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowArtWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowArtWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Get Creative!",
    "Art Workshop Awaits!",
    "Create and Inspire!",
  ],
  title: "Art Workshop",
  description: "Organize a fun art workshop.",
  longDescription:
    "Gather your friends for an inspiring art workshop! Choose a date, decide on art forms to explore, and plan activities for the session!",
  emoji: "🎨",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Art Workshop",
          emoji: "🎨",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the art workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on art forms to explore?",
            description:
              "What art forms should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What art forms should we consider?",
                emoji: "🖌",
                completeAction: {
                  question: "Decide on materials needed?",
                  description:
                    "What materials should we gather for our art projects?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🖍",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Create Art!",
    outroDescription: "Your art workshop plans are set! Enjoy the creativity!",
  },
};
